/* tslint:disable:object-literal-key-quotes */
import ajax from '@swisslife/shared-ui/src/utils/ajax/js/ajax';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import { PlayerEventCallbackFn } from './video';
import { EventNames } from '@swisslife/shared-ui/src/utils/custom-event/js/custom-event';

export interface IInit3qReturn {
	remove: () => void;
	addEventCallback: (callbackFn: PlayerEventCallbackFn) => void;
}

export const init3q = async (videoContext: GondelJqueryComponent) => {
	const playerCallbacks: PlayerEventCallbackFn[] = [];
	let js3qVideoPlayer;

	await ajax(videoContext.$ctx.data('src-url'), {
		dataType: 'script',
	});

	const initPlayer = ($player: JQuery) => {
		const { id, dataid, autoplay, controlbar, controlbarautohide, start, end, sticky, muted } = $player.data();
		const idAlphanumeric = id.replace(/[\W_]+/g, '');
		const js3q = (window as any).js3q as any;
		let videoTitle = 'no video-title';
		let progressInterval;
		let progress: 0 | 25 | 50 | 75 | 100 = 0;

		(window as any)[`video3qStateChange${idAlphanumeric}`] = (_, event) => {
			switch (event) {
				case 'ready': {
					videoTitle = js3qVideoPlayer.getVideoInfo().Title;
					break;
				}
				case 'playing': {
					triggerCustomEventCallback(EventNames.VideoPlay);
					progressInterval = setInterval(trackProgress, 1000);
					break;
				}
				case 'paused': {
					triggerCustomEventCallback(EventNames.VideoStop);
					clearInterval(progressInterval);
					break;
				}
				case 'complete': {
					triggerCustomEventCallback(EventNames.VideoComplete);
					clearInterval(progressInterval);
					progress = 0;
					break;
				}
			}
		};

		const triggerCustomEventCallback = (eventName: EventNames, includeProgress: boolean = false) => {
			playerCallbacks.forEach((playerCallback) => {
				playerCallback('3q', eventName, dataid, videoTitle, includeProgress ? progress : undefined);
			});
		};

		const trackProgress = () => {
			// return if we have already fired all three progress events
			if (progress === 75) {
				return;
			}

			const currentTime = js3qVideoPlayer.getCurrentTime();
			const currentPercentage = Math.floor((currentTime / js3qVideoPlayer.getDuration()) * 100);

			// fire progress event if we just crossed a threshold of 25/50/75 percent
			if (currentPercentage >= 25 && progress === 0) {
				progress = 25;
				triggerCustomEventCallback(EventNames.VideoProgress, true);
			}
			if (currentPercentage >= 50 && progress === 25) {
				progress = 50;
				triggerCustomEventCallback(EventNames.VideoProgress, true);
			}
			if (currentPercentage >= 75 && progress === 50) {
				progress = 75;
				triggerCustomEventCallback(EventNames.VideoProgress, true);
			}
		};

		return new Promise((resolve) => {
			const js3qiInterval = setInterval(() => {
				if (typeof js3q !== 'undefined') {
					clearInterval(js3qiInterval);
					js3qVideoPlayer = new js3q({
						'data-id': dataid,
						container: id,
						jscallback: `video3qStateChange${idAlphanumeric}`,
						playlistbar: true,
						autoplay,
						end,
						sticky,
						start,
						controlbar,
						controlbarautohide,
						muted,
					});
					js3qVideoPlayer.init();
					resolve();
				}
			}, 10);
		});
	};

	await initPlayer(videoContext.$ctx);

	return {
		remove: () => {
			js3qVideoPlayer.pause();
		},
		addEventCallback: (callbackFn) => {
			playerCallbacks.push(callbackFn);
		},
	};
};

/* tslint:enable:object-literal-key-quotes */
